import axios from 'axios'

export const getGladData = (_t) => {
  return (dispatch) => {

    axios.post(_t.apiRPC + 'atlas_getforestlossalertbyid',{
    cid:'{'+ _t.cIDs.concat() +'}',
    unit: _t.layers[_t.single ? _t.single.id : _t.activeTool].unit
  })
  .then((r)=>{
    r = {...r,title:_t.layers[_t.single ? _t.single.id : _t.activeTool].title}
    dispatch({type:'SET_GLAD_DATA',payload:_t.sgs === 'single' ? {single:r} : {group:r}})
  })
  .catch((e)=>{
    console.log(e.response);
  });

  }
}
